import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { GateService } from '@app/domains/gates/data';
import { Gate } from '@app/domains/gates/domain';
import { DashboardStore } from '@app/shared/data';
import { UserRole } from '@app/shared/domain';
import { HasRoleDirective, LocalPhonePipe } from '@app/shared/util';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.html',

  imports: [CommonModule, NgOptimizedImage, RouterModule, ButtonModule, TagModule, LocalPhonePipe, HasRoleDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardHomeComponent {
  private readonly _gateService = inject(GateService);
  private readonly _dashboardStore = inject(DashboardStore);

  readonly UserRole = UserRole;

  gates$: Observable<Gate[]> = toObservable(this._dashboardStore.selectedOrganisationId).pipe(
    switchMap((orgId) => {
      if (!orgId) {
        return of([]);
      }
      return this._gateService.getGatesByOrganisation();
    }),
  );
}
